import startCase from "lodash/startCase";

import { WSTableItem } from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import _ from "lodash";
import { IInsuranceCoverage } from "../../../../../../services/api/insurance/coverage/types";

const sentenceCase = (str: string) => _.upperFirst(_.toLower(startCase(str)));

export const mapInsuranceLimitsToTableData = (
  coverage: IInsuranceCoverage
): Array<WSTableItem<{ label: string; value: string }>> => {
  if (!coverage.limits?.length) {
    return [];
  }

  const items: Array<WSTableItem<{ label: string; value: string }>> =
    coverage.limits.map((limit, index) => {
      // TODO(artemk): update api interface
      return {
        id: `${limit.limitType}-${index}`,
        data: {
          label: sentenceCase(limit.limitType),
          value: `${formatMoney(limit.amount, limit.currency as Currency)} ${
            limit.currency ? `(${limit.currency})` : ""
          }`
        }
      };
    });

  return items;
};
